// extracted by mini-css-extract-plugin
export var closeButton = "_l8-1";
export var closeX = "_l8-3";
export var container = "_l8-0";
export var image = "_l8-2";